




















































































import { computed, defineComponent } from '@nuxtjs/composition-api'
import BrandMediaSkeleton from '../UI/BrandMediaSkeleton.vue'

export default defineComponent({
  components: { BrandMediaSkeleton },
  props: {
    showSkeleton: {
      type: Boolean,
      default: false,
      required: false,
    },
    type: {
      type: String,
      default: 'default',
    },
    img: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    code: {
      type: String,
    },
    description: {
      type: String,
      required: false,
    },
    heading: {
      type: String,
      required: false,
    },
    headingImg: {
      type: String,
    },
    date: {
      type: String,
      required: false,
    },
    views: {
      type: Number,
      required: false,
    },
    likes: {
      type: Number,
      required: false,
    },
    comments: {
      type: Number,
      required: false,
    },
    time: {
      type: String,
      required: false,
    },
    link: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const wrapperProps = computed(() => {
      if (props.code && props.link) {
        return {
          component: 'NuxtLink',
          to: `/prosto/${props.code}/${props.link}`,
        }
      }
      return { component: 'div' }
    })
    return { wrapperProps }
  },
})
